import { render } from "./HeaderComponent.vue?vue&type=template&id=5cb1c390"
import script from "./HeaderComponent.vue?vue&type=script&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Felhasznalo\\source\\repos\\favagas-gyor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__